var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeclined2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7103 46.1286C28.631 46.1286 30.9987 43.7609 30.9987 40.8402C30.9987 37.9195 28.631 35.5518 25.7103 35.5518C22.7896 35.5518 20.4219 37.9195 20.4219 40.8402C20.4219 43.7609 22.7896 46.1286 25.7103 46.1286Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7088 38.1002C32.3738 38.1002 37.7769 32.6971 37.7769 26.032C37.7769 19.367 32.3738 13.9639 25.7088 13.9639C19.0437 13.9639 13.6406 19.367 13.6406 26.032C13.6406 32.6971 19.0437 38.1002 25.7088 38.1002Z",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7103 16.5133C28.631 16.5133 30.9987 14.1456 30.9987 11.2249C30.9987 8.30422 28.631 5.93652 25.7103 5.93652C22.7896 5.93652 20.4219 8.30422 20.4219 11.2249C20.4219 14.1456 22.7896 16.5133 25.7103 16.5133Z",
    fill: "#F44336"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1126 44.1403C36.0333 44.1403 38.401 41.7726 38.401 38.8519C38.401 35.9312 36.0333 33.5635 33.1126 33.5635C30.1919 33.5635 27.8242 35.9312 27.8242 38.8519C27.8242 41.7726 30.1919 44.1403 33.1126 44.1403Z",
    fill: "#F44336"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.304 18.5016C21.2247 18.5016 23.5924 16.1339 23.5924 13.2132C23.5924 10.2925 21.2247 7.9248 18.304 7.9248C15.3833 7.9248 13.0156 10.2925 13.0156 13.2132C13.0156 16.1339 15.3833 18.5016 18.304 18.5016Z",
    fill: "#F44336"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5306 38.7243C41.4513 38.7243 43.819 36.3566 43.819 33.4359C43.819 30.5152 41.4513 28.1475 38.5306 28.1475C35.6099 28.1475 33.2422 30.5152 33.2422 33.4359C33.2422 36.3566 35.6099 38.7243 38.5306 38.7243Z",
    fill: "#F44336"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.89 23.9167C15.8107 23.9167 18.1784 21.549 18.1784 18.6283C18.1784 15.7075 15.8107 13.3398 12.89 13.3398C9.96926 13.3398 7.60156 15.7075 7.60156 18.6283C7.60156 21.549 9.96926 23.9167 12.89 23.9167Z",
    fill: "#F44336"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.515 31.321C43.4357 31.321 45.8034 28.9533 45.8034 26.0325C45.8034 23.1118 43.4357 20.7441 40.515 20.7441C37.5943 20.7441 35.2266 23.1118 35.2266 26.0325C35.2266 28.9533 37.5943 31.321 40.515 31.321Z",
    fill: "#F44336"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9017 31.321C13.8224 31.321 16.1901 28.9533 16.1901 26.0325C16.1901 23.1118 13.8224 20.7441 10.9017 20.7441C7.98098 20.7441 5.61328 23.1118 5.61328 26.0325C5.61328 28.9533 7.98098 31.321 10.9017 31.321Z",
    fill: "#F44336"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5306 23.9167C41.4513 23.9167 43.819 21.549 43.819 18.6283C43.819 15.7075 41.4513 13.3398 38.5306 13.3398C35.6099 13.3398 33.2422 15.7075 33.2422 18.6283C33.2422 21.549 35.6099 23.9167 38.5306 23.9167Z",
    fill: "#F44336"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.89 38.7243C15.8107 38.7243 18.1784 36.3566 18.1784 33.4359C18.1784 30.5152 15.8107 28.1475 12.89 28.1475C9.96926 28.1475 7.60156 30.5152 7.60156 33.4359C7.60156 36.3566 9.96926 38.7243 12.89 38.7243Z",
    fill: "#F44336"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1126 18.5016C36.0333 18.5016 38.401 16.1339 38.401 13.2132C38.401 10.2925 36.0333 7.9248 33.1126 7.9248C30.1919 7.9248 27.8242 10.2925 27.8242 13.2132C27.8242 16.1339 30.1919 18.5016 33.1126 18.5016Z",
    fill: "#F44336"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.304 44.1403C21.2247 44.1403 23.5924 41.7726 23.5924 38.8519C23.5924 35.9312 21.2247 33.5635 18.304 33.5635C15.3833 33.5635 13.0156 35.9312 13.0156 38.8519C13.0156 41.7726 15.3833 44.1403 18.304 44.1403Z",
    fill: "#F44336"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8086 31.9385L31.6139 17.1332L34.605 20.1243L19.7997 34.9296L16.8086 31.9385Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8086 20.127L19.7997 17.1358L34.605 31.9411L31.6139 34.9323L16.8086 20.127Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclined2);
export default __webpack_public_path__ + "static/media/declined 2.5cb25e38d883ded911905bdf944cc009.svg";
export { ForwardRef as ReactComponent };